import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { LoggingApiService } from '../services/logging-api.service';
import { LoggingMessageService } from '../services/logging-message.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private logger: LoggingApiService, private msgLogger: LoggingMessageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.msgLogger.debug('header-interceptor', 'intercept',  +this.authService.getSubscription(),  this.authService.getSubscriptionsAvailable(), 'Header Intercept running', '');
    if (request.method === 'GET') {
      const customRequest = request.clone({
        headers: request
          .headers.set('Cache-Control', 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0')
          .set('Pragma', 'no-cache')
          .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
      });
      return next.handle(customRequest);
    }

    return next.handle(request);
  }

}
